import { useEffect, useRef } from "react";
import Lottie, { LottieRefCurrentProps } from "lottie-react";

import styles from "./lottieAnimation.module.scss";

interface LottieAnimationProps {
  animationData: any;
  autoplay?: boolean;
  height?: number | string;
  loop?: boolean;
  width?: number | string;
}

function LottieAnimation(props: LottieAnimationProps) {
  const { animationData, autoplay = true, height = "auto", loop = false, width = "auto" } = props;
  const lottieRef = useRef<LottieRefCurrentProps | null>(null);

  useEffect(() => {
    lottieRef.current?.setSpeed(0.9);
  }, []);

  return (
    <Lottie
      className={styles.animation}
      animationData={animationData}
      autoplay={autoplay}
      loop={loop}
      lottieRef={lottieRef}
      style={{ height, width }}
    />
  );
}

export default LottieAnimation;
